import './info_panel.less';

import React from 'react';
import PropTypes from 'prop-types';

import MediaLibraryAsset from 'zoomforth_media_library/models/media_library_asset.js';

import InfoPanelAsset from './info_panel.asset.jsx';
import InfoPanelMultipleAssets from './info_panel.multiple_assets.jsx';
import InfoPanelFolder from './info_panel.folder.jsx';

const InfoPanelRootUI = ({

  currentFolder,
  isInSearchMode,
  selectedItemModels,
  pathAsFolderData,
  onAssetsDelete,
  onAssetExpand,
  onAssetReplace,
  onFolderNavigate,
  onItemsMove,
  onClearAssetSelection

})=>
  <div className="media-library-info-panel">
    {
      selectedItemModels.length === 1 ? (

        selectedItemModels[0] instanceof MediaLibraryAsset ?

          <InfoPanelAsset 
            key={selectedItemModels[0].id}
            currentFolder={currentFolder}
            isInSearchMode={isInSearchMode}
            asset={selectedItemModels[0]}
            pathAsFolderData={pathAsFolderData}
            onAssetExpand={onAssetExpand}
            onDeleteClick={onAssetsDelete}
            onFolderNavigate={onFolderNavigate}
            onMoveClick={onItemsMove}
            onAssetReplace={onAssetReplace}
            onClearAssetSelection={onClearAssetSelection}
          />

        :
          <InfoPanelFolder 
            isInSearchMode={isInSearchMode}
            folder={selectedItemModels[0]}
            pathAsFolderData={pathAsFolderData}
            onFolderNavigate={onFolderNavigate}
            onMoveClick={onItemsMove}
          />
        )

      : selectedItemModels.length >= 1 ?
        <InfoPanelMultipleAssets 
          itemCount={selectedItemModels.length}
          onMoveClick={onItemsMove}
          onDeleteClick={onAssetsDelete}
        />

      : (currentFolder.isRoot() ? 

          <div className="media-home-wrapper">
            <div className="media-placeholder-icon">
              <img src="https://d3jozdooylvm2p.cloudfront.net/images/icons/library_home.png" />
            </div>
            Select a file or folder to get started!
            <div className="media-protip">
              <strong>Pro tip:</strong> Try dragging and dropping media from your desktop onto this page.
            </div>
          </div>

        :
          <InfoPanelFolder 
            isInSearchMode={isInSearchMode}
            folder={currentFolder}
            pathAsFolderData={pathAsFolderData}
            onFolderNavigate={onFolderNavigate}
            onMoveClick={onItemsMove}
          />
        )

    }
  </div>;

InfoPanelRootUI.propTypes = {
  selectedItemModels: PropTypes.arrayOf(PropTypes.object).isRequired,
  pathAsFolderData: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    id: PropTypes.number
  })).isRequired,
  isInSearchMode: PropTypes.bool.isRequired,
  onAssetsDelete: PropTypes.func.isRequired
};


export default InfoPanelRootUI;